export const REJECTED_ORDER_STATUS = {
  posFailed: 'pos_failed',
  posManuallyLoaded: 'pos_manually_loaded',
  both: ['pos_manually_loaded', 'pos_failed']
};

export const REJECTED_ORDERS_TAB_NAMES = {
  rejectedOrders: 'rejectedOrders',
  history: 'history'
};

export const PENDING_ORDER_STATUS = {
  posPending: 'pos_pending'
};

export const PREVENT_UPDATE_STATUS = [REJECTED_ORDER_STATUS.posFailed, PENDING_ORDER_STATUS.posPending];
